import { render } from "./beneficiary-tab.vue?vue&type=template&id=49d22d27&scoped=true&ts=true"
import script from "./beneficiary-tab.vue?vue&type=script&lang=ts"
export * from "./beneficiary-tab.vue?vue&type=script&lang=ts"

import "./beneficiary-tab.vue?vue&type=style&index=0&id=49d22d27&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d22d27"]])

export default __exports__